class ServiceItem {
  constructor(
    id,
    name,
    priceEach,
    priceEachWithFee,
    quantity,
    priceTotal,
    priceTotalWithFee,
    isAccepted,
  ) {
    this.id = id;
    this.name = name;
    this.priceEach = priceEach;
    this.priceEachWithFee = priceEachWithFee;
    this.quantity = quantity;
    this.priceTotal = priceTotal;
    this.priceTotalWithFee = priceTotalWithFee;
    this.isAccepted = isAccepted;
  }
}

export default ServiceItem;
